// extracted by mini-css-extract-plugin
module.exports = {"subnav-wrap":"kr","subnavWrap":"kr","subnav-menu-header":"ks","subnavMenuHeader":"ks","subnav-menu-li":"kt","subnavMenuLi":"kt"};